import { render } from "./ForcedPassword.vue?vue&type=template&id=6b1e8899"
import script from "./ForcedPassword.vue?vue&type=script&lang=js"
export * from "./ForcedPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__